import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from 'app/shared/services';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isAuthenticated = await authService.validateAndRefreshToken();

  return isAuthenticated || router.createUrlTree(['/login']);
};
